import React from 'react';

const HorizontalCircles = () => {
  const circles = [
    { color: '#FFD700', size: 36, text: 'OC' }, // Gold
    { color: '#9966CC', size: 36, text: 'MC' }, // Amethyst
    { color: '#B87333', size: 36, text: 'IC' }, // Copper
  ];

  return (
    <div style={{ display: 'flex', alignItems: 'center', margin:'-5px' }}>
      {circles.map((circle, index) => (
        <div
          key={index}
          style={{
            width: `${circle.size}px`,
            height: `${circle.size}px`,
            backgroundColor: circle.color,
            borderRadius: '50%',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center', // Ensures text is centered
            fontSize: '12px', // Adjusts text size
            fontWeight: 'bold',
            color: '#fff', 
            margin:'-5px'
          }}
        >
          {circle.text}
        </div>
      ))}
    </div>
  );
};

export default HorizontalCircles;
